import uiConfig from "../../data/uiConfig"

type SwitchProps = {
  label?: string;
  labelColor?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  color?: string;
};

export const Switch = ({
  label,
  labelColor = uiConfig.input.labelColor,
  checked,
  onChange,
  disabled = false,
  color = uiConfig.input.switch
}: SwitchProps) => {
  const notChecked = uiConfig.input.switchNotCheck
  
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <span className={`text-sm ${disabled ? 'opacity-50' : ''} ${labelColor}`}>
          {label}
        </span >
      )}
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
        className={`relative w-11 h-6 rounded-full transition-colors duration-300 
          ${checked ? color : notChecked}
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
      >
        <span
          className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow-md transition-transform duration-300
            ${checked ? 'translate-x-5' : 'translate-x-0'}`}
        />
      </button>
    </div>
  );
};
